const convertFractionToPercent = (
  value: number,
  options?: { fixed?: number; symbol?: string | boolean; convert?: boolean },
) => {
  const { fixed, convert = true, symbol = '%' } = options || {};

  const percentValue = convert ? value * 100 : value;
  const percent = fixed ? percentValue.toFixed(fixed) : percentValue;

  const noSymbol = symbol === null || symbol === undefined;

  return !noSymbol ? `${percent}${symbol}` : +percent;
};

export default convertFractionToPercent;
